// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hero-bottom-line{background:linear-gradient(90deg,#ff3100,#ff8700 25.6%,#90ff00 48.07%,#00ffed 64.26%,#00c5ff 83.07%,#0c00fe 100.32%)}.hero-bottom-button{background:linear-gradient(90deg,#0c0cfe -28.07%,#ff3b01 141.52%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
